<template>
	<div class="page-title container-expanded container">
		<slot name="parent">
			<h2><slot /></h2>
		</slot>
	</div>
</template>

<style scoped lang="scss">
.page-title {
	display: flex;
	align-items: center;
	background-color: rgb(var(--rs-color-brand-cherry));
	height: 50px;

	:deep() {
		h2 {
			margin: 0;
			color: rgb(var(--rs-color-brand-white));
			font-size: 20px;
			font-family: var(--rs-typography-font-heading);
			text-transform: initial;
		}

		.edit {
			margin-left: auto;
		}
	}
}
</style>
